import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * Shared components use the Dutch text as translation key, so an app without a translation (the backoffice) shows
 * the key itself. ngx-translate returns a missing key unchanged; this fills in its parameters, so
 * `'{{first}} - {{last}} van {{total}} records'` still reads "1 - 10 van 25 records".
 */
@Injectable()
export class DutchKeyMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    if (!params.interpolateParams) {
      return params.key;
    }
    return params.translateService.parser.interpolate(params.key, params.interpolateParams) ?? params.key;
  }
}
